import { render } from "./AddDaysSelect.vue?vue&type=template&id=38c561ed&scoped=true"
import script from "./AddDaysSelect.vue?vue&type=script&lang=js"
export * from "./AddDaysSelect.vue?vue&type=script&lang=js"

import "./AddDaysSelect.vue?vue&type=style&index=0&id=38c561ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c561ed"]])

export default __exports__